export const setVehicles = (vehicles) => ({
  type: "SET_VEHICLES",
  payload: vehicles,
});
export const updateVehicle = (vehicle, index) => ({
  type: "UPDATE_VEHICLE",
  payload: [vehicle, index],
});

export const removeVehicle = (matricula) => ({
  type: "REMOVE_VEHICLE",
  payload: matricula,
});
